<template>
  <div id="myChart"
       style="width:100%;height:100%;"></div>
</template>
<script>
import echarts from "echarts";

export default {
  // let ratio = this.$store.state.ratio
  props: ["x", "y", "barData", "vertical", 'width', 'height', 'single'],
  data () {
    let self = this
    return {
      option: {
        tooltip: {},
        xAxis: {
          type: "category",
          name: this.x,
          axisLabel: {
            interval: 0,
            fontSize: 9 * this.$store.state.ratio.hole,
            color: "#fff" //刻度线标签颜色
          },

          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 2 * this.$store.state.ratio.hole,
            }
          },
        },
        grid: {
          // 控制图的大小，调整下面这些值就可以，
          x: "15%",
          x2: "5%",
          // y2: 20 // y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
          y: "20%",
          y2: "20%"
        },
        yAxis: {
          name: this.y,
          type: "value",
          data: [],
          axisLabel: {
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff" //刻度线标签颜色
          },
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          }, axisLine: {
            lineStyle: {
              color: '#fff',
              width: 2 * this.$store.state.ratio.hole,
            }
          },
        },
        series: [
          {
            type: "bar",
            data: [],
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function (params) {
                  var colorList
                  if (!self.single) {
                    colorList = [
                      "rgb(84,129,251)",
                      "rgb(16,253,247)",
                      "rgb(72,242,82)",
                      "rgb(231,238,54)",
                      "rgb(243,133,83)",
                      "RGBA(141, 25, 255, 1)",
                      "RGBA(125, 157, 23, 1)",
                      "RGBA(35, 74, 210, 1)",
                      "RGBA(239, 115, 122, 1)",
                      "RGBA(141, 255, 255, 1)",
                      "RGBA(125, 157, 243, 1)",
                      "RGBA(255, 254, 210, 1)"
                    ];
                  } else {
                    colorList = ["#82CF4F"]
                  }

                  return colorList[params.dataIndex];
                },
                label: {

                  show: true, //显示文本
                  position: "top", //数据值位置
                  textStyle: {
                    color: "#fff",
                    fontSize: 12 * this.$store.state.ratio.hole
                  }
                }
              }
            }
          }
        ]
      }
    };
  },
  mounted () {

    this.handleData();
    this.drawLineChart();
  },
  watch: {
    barData: {
      handler: function () {

        this.handleData();
        this.drawLineChart();
      }

    },
  },
  methods: {
    //获取数据进行处理
    handleData () {
      let barData = this.barData || [];
      let yAxisData = [];
      let seriesData = [];
      if (barData.length) {
        barData.forEach(item => {
          yAxisData.push(item.name);
          seriesData.push(item.value);
        });
      }

      this.option.xAxis.data = yAxisData;
      this.option.series[0].data = seriesData;

    },
    drawLineChart () {
      let myChart = echarts.init(this.$el);
      this.option.xAxis.name = this.x;
      this.option.yAxis.name = this.y;
      // if (!this.vertical) {
      //   let replaceX = this.option.xAxis;
      //   this.option.xAxis = this.option.yAxis;
      //   this.option.yAxis = replaceX;
      // }
      myChart.setOption(this.option, true);
    }
  }
};
</script>
<style scoped>
canvas {
  width: 100%;
}
</style>
